class FaqChroxel {
  constructor(container) {
    this.container = container;
    this.details = Array.from(this.container.querySelectorAll('.faq-chroxel__details'));

    this.details.forEach((detail) => {
      const summary = detail.querySelector('.faq-chroxel__summary');
      summary.addEventListener('click', (e) => {
        e.preventDefault();

        if (detail.classList.contains('is-open')) {
          this.close(detail);
        } else {
          this.details.forEach((d) => {
            if (d.classList.contains('is-open')) this.close(d);
          });
          this.open(detail);
        }
      });
    });

    if (this.details.length > 0) {
      this.open(this.details[0]);
    }
  }

  open(detail) {
    detail.classList.add('is-open');
    detail.setAttribute('open', '');
  }

  close(detail) {
    const answer = detail.querySelector('.faq-chroxel__answer');
    detail.classList.remove('is-open');

    answer.addEventListener('transitionend', () => {
      if (!detail.classList.contains('is-open')) {
        detail.removeAttribute('open');
      }
    }, { once: true });
  }
}

function initFaqChroxel() {
  document.querySelectorAll('.faq-chroxel').forEach((faq) => {
    new FaqChroxel(faq);
  });
}

// El script puede llegar despues de DOMContentLoaded (se carga en diferido cuando
// la seccion se acerca a pantalla), asi que hay que inicializar de una en ese caso.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqChroxel);
} else {
  initFaqChroxel();
}
